import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import { isEmpty } from 'lodash/fp';
import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';
import { BlurrableImage } from 'src/client/components/ui/BlurredImage';

type Item = {
  altText: string;
  displayOrder?: number;
  imgSrc: string;
  url: string;
};

type Props = {
  className?: string;
  extraProps?: Record<string, string>;
  item: Item;
  onError?: () => void;
  onLoad?: () => void;
  rel?: string;
  target?: string;
};

export const ImageLink = (props: Props) => {
  const { item, className, onLoad = () => null, onError, extraProps: state } = props;
  const commonProps = { className };
  const basicLink = isEmpty(props.extraProps);
  const isBlurred = useShowSfwSite();

  const img = (
    <ImageWrapper>
      <BlurrableImage
        data-order={item.displayOrder}
        src={item.imgSrc}
        alt={item.altText}
        className="img img-responsive"
        onLoad={onLoad}
        onError={onError}
        ref={(input) => input?.complete && onLoad()}
        $isBlurred={isBlurred}
      />
    </ImageWrapper>
  );

  if (/^https?:/.test(item.url)) {
    return (
      <a
        href={item.url}
        target={props.target ?? '_blank'}
        rel={props.rel ?? 'nofollow noopener noreferrer'}
        {...commonProps}
      >
        {img}
      </a>
    );
  }

  const { pathname, search, hash } = new URL(item.url, location.origin);
  const navLinkLocation = basicLink ? item.url : { pathname, state, search, hash };
  return (
    <NavLink to={navLinkLocation} target={props.target} {...commonProps}>
      {img}
    </NavLink>
  );
};

const ImageWrapper = styled.div`
  position: relative;
`;
